const agents = [
  {
    company: "BlueRock Estates",
    location: "Ikeja, Lagos",
    photo: "/images/agents/agent-1.jpg",
  },
  {
    company: "GoldenKey Properties",
    location: "Lekki, Lagos",
    photo: "/images/agents/agent-2.jpg",
  },
  {
    company: "PrimeSpace Realty",
    location: "Wuse, Abuja",
    photo: "/images/agents/agent-3.jpg",
  },
  {
    company: "Cedar Homes",
    location: "Gwarinpa, Abuja",
    photo: "/images/agents/agent-4.jpg",
  },
  {
    company: "UrbanNest Realtors",
    location: "Port Harcourt, Rivers",
    photo: "/images/agents/agent-5.jpg",
  },
  {
    company: "MegaShelter Ltd",
    location: "Asokoro, Abuja",
    photo: "/images/agents/agent-6.jpg",
  },
  {
    company: "PropertyTrust Agents",
    location: "Yaba, Lagos",
    photo: "/images/agents/agent-7.jpg",
  },
  {
    company: "GreenVille Developers",
    location: "Enugu, Enugu",
    photo: "/images/agents/agent-8.jpg",
  },
  {
    company: "HavenEdge Realty",
    location: "Ikoyi, Lagos",
    photo: "/images/agents/agent-9.jpg",
  },
  {
    company: "ShelterBay Homes",
    location: "Kano, Kano",
    photo: "/images/agents/agent-10.jpg",
  },
];

export default agents;
